<div class="item-list-component" [ngClass]="{ 'dx-rtl': rtlEnabled }" dir="{{rtlEnabled ? 'rtl' : 'ltr'}}">
  <div class="grid-buttons">
    <dx-button hint="{{ 'SHARED.PRINT' | translate }}" icon="print" (onClick)="print()"></dx-button>
  </div>
  <br />
  <dx-data-grid #auctionReportsGrid
                id="printSection"
                [rtlEnabled]="rtlEnabled"
                [dataSource]="items"
                [showBorders]="true"
                (onRowClick)="openReport($event)"
                [allowColumnReordering]="true"
                [hoverStateEnabled]="true"
                [columnAutoWidth]="true"
                [rowAlternationEnabled]="true"
                (onExporting)="onExporting($event)">
    <dxo-export [enabled]="true"></dxo-export>
    <dxo-selection mode="single"></dxo-selection>
    <dxo-filter-row [visible]="true"></dxo-filter-row>
    <dxo-filter-panel [visible]="true"></dxo-filter-panel>
    <dxo-header-filter [visible]="true"></dxo-header-filter>
    <dxo-search-panel [visible]="true"></dxo-search-panel>
    <dxo-pager [visible]="true"
               [showPageSizeSelector]="true"
               [allowedPageSizes]="[5, 10, 20, 30, 40, 50, 100, 200]"
               [showNavigationButtons]="true"
               [showInfo]="true"
               infoText="{2} {{ 'SHARED.PAGINATION_TEXT_PLACEHOLDER' | translate | slice:2 }}"></dxo-pager>
    <dxi-column [editorOptions]="{ showClearButton: true }" dataType="string" dataField="reportDesign.productName" caption="{{ 'SHARED.PRODUCT' | translate }}">
    </dxi-column>
    <dxi-column [editorOptions]="{ showClearButton: true }" dataType="string" dataField="reportDesign.name" caption="{{ 'SHARED.NAME' | translate }}">
    </dxi-column>
    <dxi-column [editorOptions]="{ showClearButton: true }" dataType="string" dataField="description" caption="{{ 'SHARED.DESCRIPTION' | translate }}" >
    </dxi-column>
    <!-- <dxi-column [editorOptions]="{ showClearButton: true }" dataType="string" dataField="filterLabel" caption="{{ 'SHARED.FILTER' | translate }}" [customizeText]="getPlainTextField">
    </dxi-column> -->
    <dxi-column type="buttons" [width]="120">
      <dxi-button hint="{{ 'OPEN' | translate }}"
                  icon="activefolder"
                  [onClick]="openReport"></dxi-button>
      <dxi-button [visible]="deleteButtonVisible"
                  hint="{{ 'SHARED.DELETE' | translate }}"
                  icon="trash"
                  [onClick]="deleteItem"></dxi-button>
    </dxi-column>
  </dx-data-grid>
</div>
<confirmation-component #confirmation title="{{ 'REPORTS.DELETE_REPORT' | translate }}"
                        message="{{ 'REPORTS.DELETE_REPORT_MESSAGE' | translate }}"
                        buttonCloseText="{{ 'SHARED.DELETE' | translate }}" cancellable="true" (close)="deleteSelected();"></confirmation-component>
